import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddTextMessagesPopup from "./AddTextMessagesPopup";

interface TextMessagesEmptyPageProps {
  onTextMessagesCreated?: (newTextMessages: any) => void;
}

export default function TextMessagesEmptyPage({
  onTextMessagesCreated,
}: TextMessagesEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Text Messages"
      colorKey="interactions"
      AddPopupComponent={AddTextMessagesPopup}
      onEntityCreated={onTextMessagesCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select a Text Message",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create a New Text Message",
          openPopup: true, // ✅ this triggers the AddTextMessagesPopup
        },
        {
          id: "send",
          type: "text",
          text: "Send Text Messages",
          direction: "right",
        },
        {
          id: "details",
          type: "text",
          text: "View Text Message History",
          direction: "down",
        },
      ]}
    />
  );
}
